import { Input, type InputProps } from "@ml/ui";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

/** Password input with a show/hide toggle. */
export function PasswordInput(props: Omit<InputProps, "type" | "suffix">) {
  const [show, setShow] = useState(false);
  return (
    <Input
      {...props}
      type={show ? "text" : "password"}
      suffix={
        <button
          type="button"
          className="gfp-pwtoggle"
          aria-label={show ? "Hide password" : "Show password"}
          aria-pressed={show}
          onClick={() => setShow((s) => !s)}
        >
          {show ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      }
    />
  );
}
